import { KdsInfoIcon } from "@kazaar-platform/design-system";
import { RiCheckboxCircleFill } from "@remixicon/react";
import { useTranslate } from "@tolgee/react";

import { type OrderItemPageActivityLogSimpleWithIconProps } from "./OrderItemPageActivityLogSimpleWithIcon.types";

export const OrderItemPageActivityLogSimpleWithIcon = ({
  title,
  icon,
  iconLabel,
  iconState,
}: OrderItemPageActivityLogSimpleWithIconProps) => {
  const { t } = useTranslate();

  return (
    <div className="prose-body-sm flex items-center gap-sp-xs2 text-text-body">
      <span>{title}</span>
      <KdsInfoIcon
        state={iconState}
        icon={icon || RiCheckboxCircleFill}
        label={t(iconLabel)}
      />
    </div>
  );
};
